var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "bg-grey-1" },
    [
      _c(
        "q-card-media",
        {
          class: _vm.course.is_blocked ? "disable-image" : "",
          nativeOn: {
            click: function($event) {
              return _vm.goToCourse()
            }
          }
        },
        [
          _vm.course.image_small
            ? _c("img", { attrs: { src: _vm.course.image_small } })
            : _vm._e(),
          !_vm.course.image_small
            ? _c("img", { attrs: { src: _vm.getPlaceholder } })
            : _vm._e()
        ]
      ),
      _c("q-card-main", { staticClass: "relative-position cursor-pointer" }, [
        _c("div", { staticClass: "line-card bg-primary absolute-top" }),
        _c("div", { staticClass: "row q-my-sm" }, [
          _c(
            "div",
            {
              staticClass: "col-10",
              on: {
                click: function($event) {
                  return _vm.goToCourse()
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12 q-title text-weight-medium",
                    class: _vm.course.is_blocked ? "text-faded" : "text-primary"
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.course.title) +
                        "\n                    "
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-12 q-mb-md" },
                  [
                    _c("q-rating", {
                      attrs: {
                        slot: "subtitle",
                        color: "amber",
                        icon: "fas fa-star",
                        max: 5,
                        readonly: ""
                      },
                      slot: "subtitle",
                      model: {
                        value: _vm.course.stars_rating,
                        callback: function($$v) {
                          _vm.$set(_vm.course, "stars_rating", $$v)
                        },
                        expression: "course.stars_rating"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "col-2 text-center",
              on: {
                click: function($event) {
                  return _vm.showCertificate()
                }
              }
            },
            [
              _c(
                "vc-donut",
                {
                  attrs: {
                    sections: !_vm.course.is_open ? _vm.sections : [],
                    size: 100,
                    unit: "%"
                  }
                },
                [
                  _vm.course.user_progress < 100 &&
                  _vm.course.group_training_user_result_status != 1 &&
                  _vm.course.group_training_user_result_status != 2 &&
                  !_vm.course.is_open
                    ? _c(
                        "h6",
                        {
                          class: _vm.course.is_blocked
                            ? "text-faded"
                            : "text-primary"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getPercentage(_vm.course.user_progress)
                              ) +
                              "%\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.course.user_progress == 100 ||
                  _vm.course.group_training_user_result_status == 1 ||
                  (_vm.course.group_training_user_result_status == 2 &&
                    !_vm.course.is_open)
                    ? _c("q-icon", {
                        attrs: {
                          name: _vm.getResult,
                          color: _vm.getResultColor,
                          size: "1.5rem"
                        }
                      })
                    : _vm._e(),
                  _vm.course.is_open
                    ? _c(
                        "q-icon",
                        {
                          attrs: {
                            name: "fal fa-clock",
                            color: "primary",
                            size: "2rem"
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "this_course_is_being_published_your_progress_will_show_when_its_finished"
                                  )
                                ) +
                                "\n                        "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.course.group_training_user_result_status == 2 &&
                  !_vm.course.is_open
                    ? _c("q-tooltip", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t("you_were_reproved_in") +
                                " " +
                                _vm.course.group_training_user_result_date
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm.selected_client_params.group_training_use_basic
                ? _c("span", { staticClass: "text-faded" }, [
                    _c("small", [_vm._v(_vm._s(_vm.$t(_vm.getTypeTraining)))])
                  ])
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row gutter-sm" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm.course.areas.length > 0
                  ? _c("p", { staticClass: "caption" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("areas")) +
                          "\n                        "
                      )
                    ])
                  : _vm._e(),
                _vm.course.areas.length > 0
                  ? _c(
                      "p",
                      { staticClass: "tooltip q-mb-sm" },
                      _vm._l(_vm.course.areas, function(area, index) {
                        return _c("span", { key: index }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.getArea(area))
                          ),
                          _vm.course.areas.length - 1 > index
                            ? _c("span", [_vm._v(", ")])
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.course.user_groups.length > 0
                  ? _c("p", { staticClass: "caption" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("groups")) +
                          "\n                        "
                      )
                    ])
                  : _vm._e(),
                _vm.course.user_groups.length > 0
                  ? _c(
                      "p",
                      { staticClass: "tooltip q-mb-sm" },
                      _vm._l(_vm.course.user_groups, function(group, index) {
                        return _c("span", { key: index }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.getGroup(group))
                          ),
                          _vm.course.user_groups.length - 1 > index
                            ? _c("span", [_vm._v(", ")])
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "col-6" }, [
                _vm.course.tags.length > 0
                  ? _c("p", { staticClass: "caption" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("tags")) +
                          "\n                        "
                      )
                    ])
                  : _vm._e(),
                _c(
                  "p",
                  { staticClass: "tooltip q-mb-sm" },
                  _vm._l(_vm.course.tags, function(tag, index) {
                    return _c("span", { key: index }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.getTag(tag))
                      ),
                      _vm.course.tags.length - 1 > index
                        ? _c("span", [_vm._v(", ")])
                        : _vm._e()
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ])
      ]),
      _c("q-card-separator"),
      _vm.actions.length > 0
        ? _c("q-card-actions", [
            _c(
              "p",
              { staticClass: "text-center fit" },
              _vm._l(_vm.actions, function(action, index) {
                return _vm.showAction(action.slug)
                  ? _c(
                      "q-btn",
                      {
                        key: index,
                        attrs: {
                          flat: "",
                          icon: action.icon,
                          color: "primary",
                          label: _vm.getLabel(action.label),
                          color: _vm.getColor(action.slug)
                        },
                        on: {
                          click: function($event) {
                            return _vm.doAction(action.slug)
                          }
                        }
                      },
                      [
                        action.tooltip
                          ? _c("q-tooltip", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t(action.tooltip)) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              }),
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }